import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';

const defaultState = {
  schedules: [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.SCHEDULES_SNAPSHOT, (state:any, payload:any) => {
    if (!Array.isArray(payload?.schedules)) {
      return state;
    }
    return {
      ...state,
      schedules: payload.schedules.filter((schedule: any) => schedule && typeof schedule === "object" && schedule.id !== undefined),
    };
  })
  .on(commonWebSocket.replace.SCHEDULE_UPDATE, (state:any, payload:any) => {
    if (!payload?.scheduleUpdate || payload.scheduleUpdate.id === undefined) {
      return state;
    }

    const newSchedules = Array.isArray(state.schedules) ? state.schedules.slice() : [];

    const scheduleToUpdateIndex = newSchedules.findIndex((schedule: any) => {
      return schedule.id === payload.scheduleUpdate.id;
    });

    if (scheduleToUpdateIndex === -1){
      newSchedules.push(payload.scheduleUpdate);
    } else {
      newSchedules[scheduleToUpdateIndex] = payload.scheduleUpdate ;
    }

    return {
      ...state,
      schedules: newSchedules
    };

  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/schedule/schedule.reducer.ts